import { useState } from "react";
import { Checkbox } from "../../../../components/Checkbox";
import { Column } from "../../../../components/Column";
import { Row } from "../../../../components/Row";
import { Input } from "../../../../components/Input";
import { Button, ChevronIcon, Combo, Content, Divider, Field, Label, Toggle } from "../../../../components/Forms";
import { level, mapInitialSearch } from "../../../../hooks/useDissertations";
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from "react-icons/ai";
import { Accordion } from "../../../../components/Accordion";
import { indices } from "../../../../mocks/indices"
import { TreeSelect } from "../../../../components/TreeSelect";
import useAnalyticsEventTracker from '../../../../hooks/useAnalyticsEventTracker';

interface paramsProps {
  formAttr?: any;
  submit(value: any, page: number): void;
  initialSearch?: string;
}

export function Form({ formAttr, submit, initialSearch = '' }: paramsProps) {
  const gaEventTracker = useAnalyticsEventTracker('Theses Form');

  const [buscaLivre, setLivre] = useState('');
  const [autor, setAutor] = useState('');
  const [orientador, setOrientador] = useState('');
  const [programaPosgraduacao, setProgramaPosgraduacao] = useState('');
  const [instituicao, setInstituicao] = useState('');
  const [initialDate, setInitialDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [index, setIndex] = useState('');

  const [isFormOpen, setIsFormOpen] = useState(false);

  const mapLevel = mapInitialSearch(initialSearch);
  const [type, setType] = useState(mapLevel);

  async function selectTypeMestrado() {
    if(type === level.MESTRADO) {
      setType(level.EMPTY);
      setIsSelectDoutorado(false)
      setIsSelectMestrado(false)
      await search(true, level.EMPTY);
    } else {
      setType(level.MESTRADO)
      setIsSelectDoutorado(false)
      setIsSelectMestrado(true)
      await search(true, level.MESTRADO);
    }
  }
  const [isSelectMestrado, setIsSelectMestrado] = useState(mapLevel === level.MESTRADO);
  
  async function selectTypeDoutorado() {
    if(type === level.DOUTORADO) {
      setType(level.EMPTY);
      setIsSelectDoutorado(false)
      setIsSelectMestrado(false)
      await search(true, level.EMPTY);
    } else {
      setType(level.DOUTORADO)
      setIsSelectDoutorado(true)
      setIsSelectMestrado(false)
      await search(true, level.DOUTORADO);
    }
  }
  const [isSelectDoutorado, setIsSelectDoutorado] = useState(mapLevel === level.DOUTORADO);

  async function onSubmit(e: any) {
    e.preventDefault();
    await search();
  }

  async function search(forceNivel = false, nivel = level.EMPTY) {
    const search_temp = {
      buscaLivre: buscaLivre,
      author: autor,
      initialDate: initialDate? `${initialDate}-01-01`: '',
      finalDate: finalDate? `${finalDate}-12-31` : '',
      orientador,
      programa_posgraduacao: programaPosgraduacao,
      instituicao,
      indice: index,
      nivel: forceNivel? nivel : type
    };
    gaEventTracker('submit', JSON.stringify(search_temp))

    await submit(search_temp, 1);
  }
  
  function maskInitialYear(value: string, setYear: Function) {
    if(Number.isNaN(Number(value))) return;
    if(Number(value) < 0) return;
    if(value.length > 4) return;
    
    if(finalDate && value >= finalDate) {
      setFinalDate(`${Number(value) + 1}`);
    }

    setYear(value);
  }

  function maskFinalYear(value: string, setYear: Function) {
    if(Number.isNaN(Number(value))) return;
    if(Number(value) < 0) return;
    if(value.length > 4) return;

    setYear(value);
  }

  return (
    <>
      <Toggle onClick={() => setIsFormOpen(!isFormOpen)} customWidth="calc(100% - 54px)" margin="auto">
        <span>Pesquisar</span>
        <AiOutlinePlusSquare display={!isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
        <AiOutlineMinusSquare display={isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
      </Toggle>
      <Accordion isOpen={isFormOpen} hasBorder={false} margin="0" customWidth="calc(46% - 12px)">
        <Content
          onSubmit={onSubmit}
        >
          <Combo marginBottom="32px">
            <Checkbox label="Mestrado" selected={isSelectMestrado} onChange={selectTypeMestrado} />
            <Checkbox label="Doutorado" selected={isSelectDoutorado} onChange={selectTypeDoutorado} />
          </Combo>
          <Row>
            <Column>
              <Label>Busca Livre</Label>
              <Input
                type="text"
                placeholder="Pesquisar"
                marginBottom="16px"
                value={buscaLivre}
                onChange={(value) => setLivre(value)}
              />
            </Column>
            <Column>
              <Label>Autor</Label>
              <Input
                type="text"
                placeholder=""
                marginBottom="16px"
                value={autor}
                onChange={(value) => setAutor(value)}
              />
            </Column>
          </Row>
          <Row>
            <Column>
              <Label>Ano da defesa</Label>
              <Row breakOnMobile={false}>
                <Field marginBottom="6px">
                  <Input
                    type={'text'}
                    placeholder="Inicial"
                    maxWidth="95px"
                    value={initialDate}
                    onChange={(value: any) => maskInitialYear(value, setInitialDate)}
                  />
                </Field>
                <Divider>A</Divider>
                <Field marginBottom="6px">
                  <Input
                    type={'text'}
                    placeholder="Final"
                    maxWidth="95px"
                    value={finalDate}
                    onChange={(value: any) => maskFinalYear(value, setFinalDate)}
                  />
                </Field>
              </Row>
            </Column>
            <Column>
              <Label>Orientador</Label>
              <Input
                type="text"
                placeholder=""
                marginBottom="16px"
                value={orientador}
                onChange={(value) => setOrientador(value)}
              />
            </Column>
          </Row>
          <Label>Programa de pós graduação</Label>
          <Input
            type="text"
            placeholder=""
            marginBottom="16px"
            value={programaPosgraduacao}
            onChange={(value) => setProgramaPosgraduacao(value)}
          />
          <Label>Instituição de ensino</Label>
          <Input
            type="text"
            placeholder=""
            marginBottom="16px"
            value={instituicao}
            onChange={(value) => setInstituicao(value)}
          />
          <Label>Índice</Label>
          <Field marginBottom="16px">
            <TreeSelect 
              data={indices} 
              marginBottom="0px"
              dropdownMaxHeight="350px"
              value={index}
              onChange={(value: any) => setIndex(value)}
            />
            <ChevronIcon size={24} />
          </Field>
          <Button>Pesquisar</Button>
        </Content>
      </Accordion>
    </>
  );
}